import React from 'react';
import { Container, Card, Button, Badge } from 'react-bootstrap';
import { deckCardStyle } from '../CardData'

const DeckViewer = ({ deck, deckName, onBack }) => {
  const cardCounts = {
	  Wisdom: deck.filter(card => card.type === 'Wisdom').length,
	Eco: deck.filter(card => card.type === 'Eco').length,
	Tech: deck.filter(card => card.type === 'Tech').length
  };

  return (
	<div className="page-transition" style={{ 
	}}>
	<div className="blur">
	  <Container className="py-4">
		<div className="d-flex justify-content-between align-items-center mb-4" style={{ color: 'white', }}>
		  <Button variant="light" onClick={onBack}>
		  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
			  <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
			</svg>
			Back
		  </Button>
		  <h2 className="text-white m-0">{deckName}</h2>
		  <div style={{ width: '70px' }}></div>
		</div>

		<Card className="mb-4">
		  <Card.Body>
			<div className="d-flex gap-3 mb-2">
			<Badge bg="info">Wisdom: {cardCounts.Wisdom}</Badge>
			  <Badge bg="success">Eco: {cardCounts.Eco}</Badge>
			  <Badge bg="secondary">Tech: {cardCounts.Tech}</Badge>
			</div>
			<div>Total Cards: {deck.length}</div>
		  </Card.Body>
		</Card>


		  {deck.map((card, index) => (
			<div key={index} style={{
			  ...deckCardStyle,
			}}>
				<img
				  src={card.imageUrl}
				  alt={card.name} className="card-image"
				/>
				<div className="card-info">
				  <div style={{ fontWeight: 'bold' }}>{card.name}</div>
					<Badge bg={
					  card.type === 'Eco' ? 'success' :
					  card.type === 'Tech' ? 'secondary' : 'info'
					}>
					  {card.type}
					</Badge>
				  <div>{card.description}</div>
				</div>
			</div>
		  ))}
	
	  </Container>
	</div>
	</div>
  );
};

export default DeckViewer;